import script from "./TheDialogBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheDialogBase.vue?vue&type=script&lang=ts&setup=true"

import "./TheDialogBase.vue?vue&type=style&index=0&id=116fb6c3&lang=sass"

const __exports__ = script;

export default __exports__